import SocialCommentSection from '../SocialCommentSection/SocialCommentSection'
import { useTranslation } from 'react-i18next'
import './contentSocialComments.css';

const ContentSocialComments = ({ contentPage }) => {
    const { t } = useTranslation(['contentProduct','landing'], { keyPrefix: 'contentSocialComments'});
    const socialCommentArray = contentPage.socialCommentArray || t('common:socialDefaultCommentArray', { defaultValue:[], returnObjects:true });
    return (
        socialCommentArray && socialCommentArray.length > 0 ?
            <SocialCommentSection title={t('whatOutStudentsSay')} socialCommentArray={socialCommentArray}/>
            :
            null
    )
}

export default ContentSocialComments